'use strict';

(function(){
  if ("performance" in window == false) {
    window.performance = {};
  }

  Date.now = (Date.now || function () {  // thanks IE8
    return new Date().getTime();
  });

  if ("now" in window.performance == false){

    var nowOffset = Date.now();

    if (performance.timing && performance.timing.navigationStart){
      nowOffset = performance.timing.navigationStart
    }

    window.performance.now = function now(){
      return Date.now() - nowOffset;
    }
  }
})();

window.logTime = function(text) {
  if (window.performance && window.performance.now) {
    console.log(window.performance.now(), ' -- ', text);
  }
};

angular.module('shiftTraderApp',
              ['ngResource', 'ngCookies', 'ui.bootstrap', 'saTooltip',
               'shiftTraderApp.filters', 'shiftTraderApp.constants', 'angularytics', 'toastr',
               'ngDropdowns', 'angularLocalStorage', 'autofill-directive', 'vjs.video', 'chart.js',
               'ngAnimate', 'ui.sortable', 'ui.router', 'angucomplete', 'nvd3ChartDirectives',
               'angularPayments', 'ui.select', 'ngSanitize', 'uuid4', 'angular-gestures', 'saTemplates', 'angucomplete-alt', 'angular-confirm', 'RecursionHelper'])
  .config(['$provide', 'AngularyticsProvider', 'uibTimepickerConfig', '$uibTooltipProvider', '$stateProvider', '$urlRouterProvider', '$compileProvider', '$logProvider', '$animateProvider', '$httpProvider', 'toastrConfig',
      function ($provide, AngularyticsProvider, uibTimepickerConfig, $uibTooltipProvider, $stateProvider, $urlRouterProvider, $compileProvider, $logProvider, $animateProvider, $httpProvider, toastrConfig) {

    //PERF: Use $applyAsync to allow multiple XHR requests to queue up before forcing a $digest cycle
    //  Without it, each XHR request forces a digest all on its own
    $httpProvider.useApplyAsync(true)
    $httpProvider.interceptors.push('rxHttpInterceptor')

    angular.extend(toastrConfig, {
      progressBar: true,
      timeOut: 2500
    })

    AngularyticsProvider.setEventHandlers(['GoogleUniversal']);

    $logProvider.debugEnabled(false);

    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|sms|mms):/);

    $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled|modal-dialog|sa-body).)*$/);

    $provide.decorator('$exceptionHandler', ['$delegate', function($delegate) {
      return function(exception, cause) {
        $delegate(exception, cause);
        console.log(exception);
        Rollbar.error(exception);
      };
    }]);

    $provide.decorator('$uibModal', ['$delegate', 'EventTrackingService', '$uibModalStack', 'OverlayManagementService', '$interval', 'GlobalRxFeed',
      function($delegate, EventTrackingService, $uibModalStack, OverlayManagementService, $interval, GlobalRxFeed) {
      var WORKPERIODCONTAINER = '.work_period_container_scroller';
      var conditionalToggle = function() {
        if ($(WORKPERIODCONTAINER).length > 0 && $uibModalStack.length() === 1) {
          $(WORKPERIODCONTAINER).trigger('DragOn.toggle');
        }
      };

      $delegate.setCallbacks(function(modalOptions) {
        if (modalOptions.templateUrl && modalOptions.templateUrl === 'views/organizationSignupSimple.html') {

          $('body').addClass('signup-modals-open');
        }

        EventTrackingService.addEvent('modal open', {view: modalOptions.templateUrl, metadata: _.pick(modalOptions, 'metadata')});

        if (modalOptions.rxName) {
          GlobalRxFeed.push('modal-open', modalOptions.rxName, modalOptions)
        }

        OverlayManagementService.clearOverlays('mwpGuideBar');
        if ($('body').hasClass('note-overlay-open')) {

          var checker = $interval(function() {
            var e = $('.modal:first');

            if (e.length > 0) {
              var zIndex = parseInt(e.css('z-index')) + 10000;
              e.css({'z-index': zIndex});
              $interval.cancel(checker);
            }
          }, 10);

          var checkerBackdrop = $interval(function() {
            var e = $('.modal-backdrop');

            if (e.length > 0) {
              var zIndex = parseInt(e.css('z-index')) + 10000;
              e.css({'z-index': zIndex});
              $interval.cancel(checkerBackdrop);
            }
          }, 10);

        }

        var keepers = {
          'background-color': $('body').css('background-color')
        }
        $('body').removeAttr('style')
        $('body').css(keepers)

        conditionalToggle();
      }, function(modalOptions) {
        if (modalOptions.templateUrl && modalOptions.templateUrl === 'views/organizationSignupSimple.html') {
          $('body').removeClass('signup-modals-open');
        }

        EventTrackingService.addEvent('modal closed', {view: modalOptions.templateUrl, metadata: _.pick(modalOptions, 'metadata')});

        if (modalOptions.rxName) {
          GlobalRxFeed.push('modal-closed', modalOptions.rxName, modalOptions)
        }

        if ($('body').hasClass('note-overlay-open')) {
          var e = $('.modal-backdrop');

          if (e.length > 0) {
            var zIndex = parseInt(e.css('z-index')) - 10000;
            e.css({'z-index': zIndex});
          }
        }

        var keepers = {
          'background-color': $('body').css('background-color')
        }
        $('body').removeAttr('style')
        $('body').css(keepers)

        conditionalToggle();
      }, function(modalOptions) {
        if (modalOptions.templateUrl && modalOptions.templateUrl === 'views/organizationSignupSimple.html') {
          $('body').removeClass('signup-modals-open');
        }
        EventTrackingService.addEvent('modal dismissed', {view: modalOptions.templateUrl, metadata: _.pick(modalOptions, 'metadata')});

        if (modalOptions.rxName) {
          GlobalRxFeed.push('modal-dismissed', modalOptions.rxName, modalOptions)
        }

        if ($('body').hasClass('note-overlay-open')) {
          var e = $('.modal-backdrop');

          if (e.length > 0) {
            var zIndex = parseInt(e.css('z-index')) - 10000;
            e.css({'z-index': zIndex});
          }
        }

        var keepers = {
          'background-color': $('body').css('background-color')
        }
        $('body').removeAttr('style')
        $('body').css(keepers)

        conditionalToggle();
      });

      return $delegate;
    }]);

    $uibTooltipProvider.options({
      popupDelay: 300
    });

    angular.extend(uibTimepickerConfig, {
      minuteStep: 15
    });

    $urlRouterProvider.deferIntercept();

    $urlRouterProvider
        .rule(function($injector, $location) {
          var qs;
          /* jshint ignore:start */
          qs = (function(a) {
            if (a == "") {return {};}
            var b = {};
            for (var i = 0; i < a.length; ++i) {
              var p=a[i].split('=');
              if (p.length !== 2) { continue; }
              b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
            }
            return b;
          })(window.location.search.substr(1).split('&'));

          if (qs && qs.resetCode) {
            $injector.get('HardNavigationService').replace('resetPassword/' + qs.resetCode);
          }

          if (qs && qs.activationCode) {
            $injector.get('HardNavigationService').replace('activateUser/' + qs.activationCode);
          }
        })
        .when('/workPeriods', '/workPeriods/me')
        .when(/(manageWorkPeriods|daysOff)\/?$/, ['$match', 'Session', 'TimeService', function($match, Session, TimeService) {

          var dateProvided = TimeService.getBeginningOfDayFromDate(moment.utc()).add(1, 'days');
          if (!_.isNull(Session.getCurrentCalendarDate()) && !_.isUndefined(Session.getCurrentCalendarDate())) {
            var lastDate = TimeService.getBeginningOfDayFromDate(moment(Session.getCurrentCalendarDate()));
            if (lastDate.isValid()) {
              dateProvided = lastDate;
            }
          }
          var newRoute = '';
          if (/daysOff/.test($match[0])) {
            var daysOffPage = Session.getLastUsedDaysOffView() || 'pending';
            if (daysOffPage === 'pendingList') {
              newRoute = '/' + $match[0] + '/' + daysOffPage;
            } else {
              newRoute = '/' + $match[0] + '/' + dateProvided.startOf('month').format('YYYY-MM-DD') + '/' + daysOffPage;
            }
          } else {
            newRoute = '/' + $match[0] + '/' + dateProvided.format('YYYY-MM-DD');
          }

          return newRoute;
        }])
        .otherwise('/enter');


    $stateProvider
      .state('enter', {
        url: '/enter',
        template: '<div class="enter-container"><div class="spinner"><div class="spinner-container container1"><div class="circle1"></div><div class="circle2"></div><div class="circle3"></div><div class="circle4"></div></div><div class="spinner-container container2"><div class="circle1"></div><div class="circle2"></div><div class="circle3"></div><div class="circle4"></div></div><div class="spinner-container container3"><div class="circle1"></div><div class="circle2"></div><div class="circle3"></div><div class="circle4"></div></div></div><div class="enter-loading">Loading</div></div></div>',
        controller: 'EnterCtrl',
        onEnter: ['Session', '$q', '$state', '$stateParams', '$location','ServerUrls', 'toastr', '$uibModal', function(Session, $q, $state, $stateParams, $location, ServerUrls, toastr, $uibModal) {
          var qs;
          /* jshint ignore:start */
          qs = (function(a) {
            if (a == "") {return {};}
            var b = {};
            for (var i = 0; i < a.length; ++i) {
              var p=a[i].split('=');
              if (p.length !== 2) { continue; }
              b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
            }
            return b;
          })(window.location.search.substr(1).split('&'));
          /* jshint ignore:end */

          function openNewFeaturesModal (me) {
            var modalInstance = $uibModal.open({
              size: 'md2',
              templateUrl: 'views/newFeaturesModal.html',
              controller: 'NewFeaturesModalCtrl',
              controllerAs: 'newFeaturesCtrl',
              resolve: { params: function() { return { me: me } } }
            })
          }

          if (_.has($stateParams, 'activationCode')) {
            Session.clearSession();
            $location.path('activateUser/' + $stateParams.activationCode);
          } else if (_.has(qs, 'activationCode')) {
            Session.clearSession();
            $location.path('activateUser/' + qs.activationCode);
          } else if (_.has($stateParams, 'resetCode')) {
            Session.clearSession();
            $location.path('resetPassword/' + $stateParams.resetCode);
          } else if (_.has(qs, 'resetCode')) {
            Session.clearSession()
            $location.path('resetPassword/' + qs.resetCode);
          } else if (Session.isLoggedIn()) {
            $q.all([ Session.getMe(), Session.getCurrentOrg() ])
              .then(function (result) {
                var currentMemb = lodash.find(result[0].memberships, { organization_id: Session.getCurrentOrgId() })
                if (currentMemb && currentMemb.role === 'admin' && !lodash.has(result[0].completed_tours, 'newfeature-payrates-tour') && moment(result[1].created_at).isBefore('2017-07-01')) {
                  toastr.info('We have updated Shift Agent with some new features. Click here to learn more!', 'New Features!', {
                    allowHtml: true,
                    closeButton: true,
                    timeOut: 0,
                    extendedTimeOut: 0,
                    onTap: function () {
                      openNewFeaturesModal(result[0])
                    }
                  })
                }
              })
          } else {
            $state.go('login', {resetCode: undefined, activationCode: undefined});
          }
        }]
      })
      .state('login', {
        url: '/login',
        onEnter: ['Session', '$state', '$rootScope', function(Session, $state, $rootScope) {
          if (Session.isLoggedIn()) {
            $state.go('enter');
          } else {
            $rootScope.transitionPageState('login');
          }
        }]
      })
      .state('messages', {
        url: '/messages',
        templateUrl: 'views/messages.html',
        controller: 'MessagesCtrl',
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          notifications:['Notifications', 'me', function(Notifications, me) {
            return Notifications.getNewNotifications();
          }]
        }
      })
      .state('profile', {
        url: '/profile/:userId',
        abstract: true,
        template: '<div ui-view style="height:100%;"></div>',
        resolve: {
          user: ['Users', '$stateParams', function (Users, $stateParams) {
            if ($stateParams.userId === 'me') {
              return Users.whoAmI();
            } else {
              return Users.getById($stateParams.userId);
            }
          }],
          positions: ['Positions', function(Positions) {
            return Positions.getAllInOrg();
          }],
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          org: ['Organizations', function (Organizations) {
            return Organizations.getCurrentOrg();
          }]
        }
      })
      .state('profile.main', {
        url: '',
        templateUrl: 'views/employeeProfile/employeeProfile.html',
        controller: 'EmployeeProfileCtrl'
      })
      .state('profile.availability', {
        url: '/availability',
        abstract: true,
        template: '<div ui-view style="height:100%;"></div>',
        resolve: {
          pending_in_review_availability_sets: ['AvailabilitySets', 'user', function(AvailabilitySets, user) {
            return AvailabilitySets.getUserPendingAndInReviewSets(user.id);
          }],
          userAvailabilityChangeRequests: ['UserAvailabilityChangeRequests', 'org', '$stateParams', function(UserAvailabilityChangeRequests, org, $stateParams) {
            return UserAvailabilityChangeRequests.getAll({organization_id: org.id, user_id: $stateParams.userId});
          }]
        }
      })

      .state('profile.availability.main', {
        url: '',
        templateUrl: 'views/profile.availability.main.html',
        controller: 'ProfileAvailabilityCtrl'
      })

      .state('profile.availability.changeRequest', {
        url: '/changeRequest/:uacrId',
        templateUrl: 'views/profile.availability.changeRequest.html',
        controller: 'ProfileAvailabilityChangeRequestCtrl',
        resolve: {
          userAvailabilityChangeRequest: ['UserAvailabilityChangeRequests', '$stateParams', function(UserAvailabilityChangeRequests, $stateParams) {
            return UserAvailabilityChangeRequests.getById($stateParams.uacrId);
          }]
        }
      })

      .state('profile.availability.sets', {
        url: '/sets',
        abstract: true,
        template: '<div ui-view style="height:100%;"></div>'
      })

      .state('profile.availability.sets.new', {
        url: '/new',
        templateUrl: 'views/profile.availability.sets.new.html',
        controller: 'ProfileAvailabilitySetsNewCtrl',
        resolve: {
          userAvailabilityChangeRequests: ['UserAvailabilityChangeRequests', 'org', '$stateParams', function(UserAvailabilityChangeRequests, org, $stateParams) {
            return UserAvailabilityChangeRequests.getAll({organization_id: org.id, user_id: $stateParams.userId});
          }],
          last_disapproved_availability_set: ['AvailabilitySets', '$stateParams', function(AvailabilitySets, $stateParams) {
            return AvailabilitySets.getAll({
              user_id: $stateParams.userId,
              state: AvailabilitySets.stateMapping.DISAPPROVED,
              limit: 1,
              order_by: 'created_at',
              order_direction: 'desc'
            })
          }],
          canCreateAvailabilitySet: ['UserPermissionsService', 'me', function(UserPermissionsService, me) {
            return UserPermissionsService.can('availability_sets.create', 'current');
          }]
        }
      })
      .state('profile.availability.sets.edit', {
        url: '/:setId/edit',
        templateUrl: 'views/profile.availability.sets.edit.html',
        controller: 'ProfileAvailabilitySetsEditCtrl',
        resolve: {
          availabilitySet: ['AvailabilitySets', '$stateParams', function(AvailabilitySets, $stateParams) {
            return AvailabilitySets.getById($stateParams.setId);
          }]
        }
      })

      .state('profile.availability.sets.view', {
        url: '/:setId/view',
        templateUrl: 'views/profile.availability.sets.view.html',
        controller: 'ProfileAvailabilitySetsViewCtrl',
        resolve: {
          availabilitySet: ['AvailabilitySets', '$stateParams', function(AvailabilitySets, $stateParams) {
            return AvailabilitySets.getById($stateParams.setId);
          }]
        }
      })

      .state('organizationProfile', {
        abstract: true,
        url: '/organizationProfile/:orgId?tab',
        template: '<div ui-view></div>',
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          org: ['Organizations', '$stateParams', function (Organizations, $stateParams) {
            return Organizations.getById($stateParams.orgId);
          }],
          allPositions: ['Positions', '$stateParams', function(Positions, $stateParams) {
            return Positions.getAllInOrg($stateParams.orgId);
          }],
          initialTab: ['$stateParams', function ($stateParams) {
            return $stateParams.tab
          }],
        }
      })
      .state('organizationProfile.show', {
        url: '',
        templateUrl: 'views/organizationProfile/organizationProfile.html',
        controller: 'OrganizationProfileCtrl',
        controllerAs: 'orgProfileCtrl'
      })
      .state('workPeriods', {
        url: '/workPeriods/:userId',
        controller:'WorkPeriodsCtrl',
        templateUrl:'views/WorkPeriods.html',
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          upcomingWorkPeriods: ['WorkPeriods', 'Users', '$stateParams', 'me', function(WorkPeriods, Users, $stateParams, me) {
            return WorkPeriods.getByUserId($stateParams.userId);
          }],
          selectedUser: ['$stateParams', 'Users', function($stateParams, Users) {
            return Users.getById($stateParams.userId).then(function(u) {
              return [u];
            });
          }],
          org: ['Organizations', function (Organizations) {
            return Organizations.getCurrentOrg();
          }]
        }
      })
      .state('manageWorkPeriods', {
        abstract: true,
        url: '/manageWorkPeriods',
        template: '<div ui-view></div>',
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          allPositions: ['Positions', function(Positions) {
            return Positions.getAllInOrg({status: 'any'});
          }],
          org: ['Organizations', function (Organizations) {
            return Organizations.getCurrentOrg();
          }]
        }
      })
      .state('manageWorkPeriods.date', {
        url: '/:date',
        templateUrl: 'views/manageWorkPeriods.html',
        controller: 'ManageWorkPeriodsCtrl',
        resolve: {
          allWorkPeriods: ['WorkPeriodStore', '$stateParams', 'TimeService', 'me', function(WorkPeriodStore, $stateParams, TimeService, me) {
            var dateProvided = moment($stateParams.date);
            var twix;
            if (dateProvided.isValid()) {
              twix = TimeService.getWeekTwixFromMoment(dateProvided, 1, 0);
              return WorkPeriodStore.getWorkPeriodsBetween(twix.start, twix.end);
            } else {
              twix = TimeService.getWeekTwixFromMoment(moment.utc(), 1, 0);
              return WorkPeriodStore.getWorkPeriodsBetween(twix.start, twix.end);
            }
          }],
          theDate: ['$stateParams', 'TimeService', 'me', '$rootScope', function($stateParams, TimeService, me, $rootScope) {
            var tempDate = TimeService.getBeginningOfDayFromDate(moment($stateParams.date));
            var returnedDate = tempDate;

            if (!tempDate.isValid()) {
              returnedDate = TimeService.getBeginningOfDayFromDate(moment.utc());
            }
            $rootScope.setMWPDate(returnedDate);
            return returnedDate;
          }]
        }
      })
      .state('trades', {
        url: '/trades',
        templateUrl: 'views/trades.html',
        controller: 'TradesCtrl',
        resolve: {
          trades: ['$q', 'ShiftTradesResource', 'Users', 'Session', 'me', function($q, ShiftTradesResource, Users, Session, me) {
            var defer = $q.defer();
            ShiftTradesResource.query({user_id: 'me', active: true}, defer.resolve);
            return defer.promise;
            //var defer = $q.defer();
            //
            //if (!_.isNull(Session.me) && !_.isUndefined(Session.me)) {
            //  ShiftTradesResource.query({user_id: Session.me.id, active: true}, defer.resolve);
            //  return defer.promise;
            //} else {
            //  return Users.whoAmI()
            //    .then(function(u) {
            //      var userIdToUse = undefined;
            //      if (_.isUndefined(u) || _.isUndefined(u.id)) {
            //        Rollbar.debug('Users.whoAmI returned undefined or u.id as undefined', {session_me: Session.me, returned_obj: u, resolve_me: me});
            //
            //        if (Session.me && Session.me.id) {
            //          userIdToUse = Session.me.id;
            //        } else if (me && me.id) {
            //          userIdToUse = me.id;
            //        } else {
            //          Rollbar.error('When loading /trades route: no userId availabile', {session_me: Session.me, returned_obj: u, resolve_me: me});
            //        }
            //      } else {
            //        userIdToUse = u.id;
            //      }
            //
            //      if (_.isUndefined(userIdToUse)) {
            //        flash.error('Sorry! We experienced at error that requires you to log in again.');
            //        Session.logout();
            //      } else {
            //        ShiftTradesResource.query({user_id: userIdToUse, active: true}, defer.resolve);
            //        return defer.promise;
            //      }
            //
            //    });
            //}
          }],
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }]
        }
      })
      .state('pickups', {
        url: '/pickups',
        templateUrl: 'views/pickups.html',
        controller: 'PickupsCtrl',
        resolve: {
          trades: ['ShiftTradesResource', '$q', 'me', function(ShiftTradesResource, $q, me) {
            var defer = $q.defer();
            ShiftTradesResource.query({active: true}, defer.resolve);
            return defer.promise;
          }],
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }]
        }
      })
      .state('manageTrades', {
        url: '/manageTrades',
        templateUrl: 'views/manageTrades.html',
        controller: 'ManageTradesCtrl',
        resolve: {
          trades: ['ShiftTradesResource', '$q', 'me', function(ShiftTradesResource, $q, me) {
            var defer = $q.defer();
            ShiftTradesResource.query({active: true}, defer.resolve);
            return defer.promise;
          }],
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          allDepartments: ['Departments', function(Departments) {
            return Departments.getAll();
          }]
        }
      })
      .state('trade', {
        url: '/trade/:tradeId',
        templateUrl: 'views/trade.html',
        controller: 'TradeCtrl',
        resolve: {
          trade: ['ShiftTradesResource', '$stateParams', '$q', 'me',function (ShiftTradesResource, $stateParams, $q, me) {
            var defer = $q.defer();
            ShiftTradesResource.get({id: $stateParams.tradeId}, defer.resolve);
            return defer.promise;
          }],
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          org: ['Organizations', function (Organizations) {
            return Organizations.getCurrentOrg();
          }]
        }
      })
      .state('dayOffLimits', {
        url: '/dayOffLimits',
        templateUrl: 'views/daysOff/dayOffLimits.html',
        controller: 'DayOffLimitsCtrl',
        controllerAs: 'vm',
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          org: ['Organizations', function (Organizations) {
            return Organizations.getCurrentOrg();
          }],
          currentAndFutureLimits: ['DayOffLimitStore', 'TimeService', 'org', function(DayOffLimitStore, TimeService, org) {
            var startDate = TimeService.getBeginningOfDayFromDate(TimeService.getNowInStoreTime());
            var endDate = TimeService.getBeginningOfDayFromDate(moment(startDate).add(370, 'days'));
            return DayOffLimitStore.getLimitsBetween(startDate, endDate);
          }]
        }
      })
      .state('daysOff', {
        url: '/daysOff',
        abstract: true,
        templateUrl: 'views/daysOff/daysOffOrgParent.html',
        resolve: {
          org: ['Organizations', function(Organizations) {
            return Organizations.getCurrentOrg();
          }],
          me: ['Users', 'DaysOffStore', function (Users, DaysOffStore) {
            DaysOffStore.setAnonymizeRequests(false);
            return Users.whoAmI();
          }],
          allMinUsers: ['Users', function(Users) {
            return Users.getAll({view: 'med'})
          }]
        }
      })
      .state('daysOff.intermediate', {
        url: '',
        abstract: true
      })
      .state('daysOff.intermediate.pendingList', {
        url: '/pendingList',
        views: {
          'top@daysOff': {
            controller: 'DaysOffTopCtrl',
            templateUrl: 'views/daysOff/daysOffOrgTop.html'
          },
          'content@daysOff': {
            controller: 'DaysOffContentPendingListCtrl',
            templateUrl: 'views/daysOff/daysOffOrgPendingList.html'
          }
        },
        resolve: {
          daysOff: ['AvailabilityRules', 'TimeService', '$stateParams', 'me', function(AvailabilityRules, TimeService, $stateParams, me) {
            return AvailabilityRules.getAllDaysOffNeedingApproval();
          }]
        }
      })
      .state('daysOff.intermediate.date', {
        url: '/:date',
        abstract: true,
        views: {
          'top@daysOff': {
            controller: 'DaysOffTopCtrl',
            templateUrl: 'views/daysOff/daysOffOrgTop.html'
          },
          'content@daysOff': {
          }
        },
        resolve: {
          daysOff: ['DaysOffStore', 'TimeService', '$stateParams', 'me', function(DaysOffStore, TimeService, $stateParams, me) {
            var baseDate = TimeService.getBeginningOfDayFromDate($stateParams.date);

            var startDate = moment(baseDate).startOf('month').subtract(1, 'week');
            var endDate = moment(baseDate).endOf('month').add(1, 'week');

            return DaysOffStore.getDaysOffBetween(startDate, endDate, true);
          }]
        }
      })
      .state('daysOff.intermediate.date.pending', {
        url: '/pending',
        views: {
          'content@daysOff': {
            controller: 'DaysOffContentPendingCtrl',
            templateUrl: 'views/daysOff/daysOffOrgPending.html'
          }
        }
      })
      .state('daysOff.intermediate.date.report', {
        url: '/report',
        views: {
          'content@daysOff': {
            controller: 'DaysOffContentPendingCtrl',
            templateUrl: 'views/daysOff/daysOffOrgReport.html'
          }
        }
      })
      .state('daysOff.intermediate.date.calendarList', {
        url: '/calendarList/{id}?userId',
        params: {
          id: {
            value: null,
            squash:true
          },
          userId: {
            value: null
          }
        },
        views: {
          'content@daysOff': {
            controller: 'DaysOffContentCalendarListCtrl',
            templateUrl: 'views/daysOff/daysOffOrgCalendarList.html'
          }
        }
      })

        .state('availability', {
          url: '/availability',
          abstract: true,
          template: '<div ui-view=""></div>',
//          controller: 'AvailabilityManagementCtrl',
//          templateUrl: 'views/availability.html',
          resolve: {
            org: ['Organizations', function(Organizations) {
              return Organizations.getCurrentOrg();
            }],
            me: ['Users', function (Users) {
              return Users.whoAmI();
            }],
            allMedUsers: ['Users', function(Users) {
              return Users.getAll({view: 'med'})
            }]

          }
        })

      .state('availability.main', {
        url: '',
//        template: '<div ui-view=""></div>',
        controller: 'AvailabilityManagementCtrl',
        templateUrl: 'views/availability.html',
        resolve: {
          availability_change_requests: ['AvailabilityChangeRequests', function(AvailabilityChangeRequests) {
            return AvailabilityChangeRequests.getAll();
          }]
        }
      })

      .state('availability.analysis', {
        url: '/analysis',
        controller: 'AvailabilityManagementAnalysisCtrl',
        templateUrl: 'views/availability.analysis.html',
        resolve: {
          availability_change_requests: ['AvailabilityChangeRequests', function(AvailabilityChangeRequests) {
            return AvailabilityChangeRequests.getAll();
          }],
          organization_availability_sets: ['AvailabilitySets', 'org', function(AvailabilitySets, org) {
            return AvailabilitySets.getAll({
              state: [AvailabilitySets.stateMapping.APPROVED, AvailabilitySets.stateMapping.IN_REVIEW].join(','),
              organization_id: org.id
            });
          }],
          allDepartments: ['Departments', function(Departments) {
            return Departments.getAll();
          }],
          allPositions: ['Positions', function(Positions) {
            return Positions.getAllInOrg()
          }]
        }
      })

      .state('availability.requests', {
        url: '/requests',
        abstract: true,
        template: '<div ui-view=""></div>',
        resolve: {
          availability_sets_in_review: ['AvailabilitySets', function(AvailabilitySets) {
            return AvailabilitySets.getAll({
              state: AvailabilitySets.stateMapping.IN_REVIEW
            });
          }],
          availability_change_requests: ['AvailabilityChangeRequests', function(AvailabilityChangeRequests) {
            return AvailabilityChangeRequests.getAll({expires_at: moment.utc().subtract(3, 'months').startOf('day').format()});
          }]
        }
      })


      .state('availability.requests.list', {
        url: '',
        controller: 'AvailabilityManagementRequestsCtrl',
        templateUrl: 'views/availability.requests.list.html',
        resolve: {
          availability_sets: ['AvailabilitySets', function(AvailabilitySets) {
            return AvailabilitySets.getAll({
              state: AvailabilitySets.stateMapping.IN_REVIEW
            });
          }]
        }
      })

      .state('availability.requests.new', {
        url: '/new',
        controller: 'AvailabilityManagementNewRequestCtrl',
        templateUrl: 'views/availability.requests.new.html',
        resolve: {
          availability_sets: ['AvailabilitySets', function(AvailabilitySets) {
            return AvailabilitySets.getAll({
              state: AvailabilitySets.stateMapping.IN_REVIEW
            });
          }]
        }
      })


      .state('availability.requests.view', {
        url: '/:acrId',
        controller: 'AvailabilityManagementViewRequestCtrl',
        templateUrl: 'views/availability.requests.view.html',
        resolve: {
          availability_change_request: ['AvailabilityChangeRequests', '$stateParams', function(AvailabilityChangeRequests, $stateParams) {
            return AvailabilityChangeRequests.getById($stateParams.acrId);
          }]
        }
      })
      .state('employees', {
        url: '/employees',
        templateUrl: 'views/employees.html',
        controller: 'EmployeesCtrl',
        resolve: {
          me: ['Users', function(Users) {
            return Users.whoAmI();
          }],
          users: ['Users', function (Users) {
            return Users.getAll({view: 'med'});
          }],
          positions: ['Positions', function(Positions) {
            return Positions.getAllInOrg();
          }],
          org: ['Organizations', function (Organizations) {
            return Organizations.getCurrentOrg();
          }]
        }
      })
      .state('storeAnnouncements', {
        abstract: true,
        url: '/storeAnnouncements',
        template: '<div ui-view></div>',
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          allPositions: ['Positions', function(Positions) {
            return Positions.getAllInOrg();
          }],
          org: ['Organizations', function (Organizations) {
            return Organizations.getCurrentOrg();
          }],
          canViewAvailabilityChangeRequests: ['UserPermissionsService', 'me', function(UserPermissionsService, me) {
            return UserPermissionsService.can('availability_change_requests.view', 'current');
          }]
        }
      })
      .state('storeAnnouncements.list', {
        url: '',
        templateUrl: 'views/announcements/announcements.list.html',
        controller: 'OrganizationMessagesListCtrl',
        resolve: {
          currentOrgMessages: ['OrganizationMessages', 'Session', 'me', function(OrganizationMessages, Session, me) {
            return OrganizationMessages.getCurrentOrganizationMessages(Session.getCurrentOrgId());
          }],
          availability_change_requests: ['AvailabilityChangeRequests', 'me', 'canViewAvailabilityChangeRequests', function(AvailabilityChangeRequests, me, canViewAvailabilityChangeRequests) {
            if (canViewAvailabilityChangeRequests) {
              return AvailabilityChangeRequests.getAll();
            } else {
              return [];
            }
          }]
        }
      })
      .state('storeAnnouncements.new', {
        url: '/new',
        templateUrl: 'views/announcements/announcements.new.html',
        controller: 'OrganizationMessageNewWriteCtrl'
      })
      .state('storeAnnouncements.show', {
        url: '/:id',
        templateUrl: 'views/announcements/announcements.show.html',
        controller: 'OrganizationMessageShowCtrl',
        resolve: {
          orgMessage: ['OrganizationMessages', '$stateParams', 'me', function(OrganizationMessages, $stateParams, me) {
            return OrganizationMessages.getMessageById($stateParams.id);
          }]
        }
      })
      .state('userPayRates', {
        url: '/payRates',
        templateUrl: 'views/userPayRates.html',
        controller: 'UserPayRatesCtrl',
        resolve: {
          me: ['Users', function(Users) {
            return Users.whoAmI();
          }]
        }
      })
      .state('resetPassword', {
        url: '/resetPassword/:resetCode',
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.transitionPageState('resetPassword');
        }]
      })
      .state('activateUser', {
        url: '/activateUser/:activationCode',
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.transitionPageState('activate');
        }]
      })
      .state('setHostnameAndEnv', {
        url: '/setHostnameAndEnv/:hostname/:env',
        resolve: {
          setBackend: ['$location', '$stateParams', 'ServerUrls', 'Session',
            function($location, $stateParams, ServerUrls, Session) {
            if (ServerUrls.isHostnameDefined($location.host())) {
              $location.path('/');
            } else {
              ServerUrls.setHostname($stateParams.hostname);
              ServerUrls.setEnv($stateParams.env);
              ServerUrls.setupCurrentServer();
              Session.logout();
            }
          }]
        }
      })
      .state('clearHostnameAndEnv', {
        url: '/clearHostnameAndEnv',
        resolve:  {
          setBackend: ['$location', '$stateParams', 'ServerUrls', 'Session', function($location, $stateParams, ServerUrls, Session) {
            if (ServerUrls.isHostnameDefined($location.host())) {
              $location.path('/');
            } else {
              ServerUrls.clearHostnameAndEnv();
              Session.logout();
            }
          }]
        }
      })
      .state('logout', {
        url: '/logout',
        onEnter: ['$location', 'Session', function($location, Session) {
          Session.logout();
          $location.path('/login');
        }]
      })
      .state('signup', {
        url: '/signup',
        onEnter: ['$rootScope', 'Session', function($rootScope, Session) {
          $('body').addClass('signup-modals-open');
          Session.logout(true);
          $rootScope.transitionPageState('signup');

          $rootScope.openOrganizationSignupWizardModal();
        }]
      });
  }])
  .run(['Angularytics', '$rootScope', '$location', '$timeout', '$q', '$urlRouter', '$window',
      '$uibModal', 'OrganizationMessageResponses', 'Session', '$state', 'toastr',
      'ClientTypeDetectionService', 'ServerUrls', '$interval', 'EventTrackingService',
      '$uibModalStack', 'ShepherdTourService', '$templateCache', '$confirmModalDefaults', 'GlobalRxFeed',
      function(Angularytics, $rootScope, $location, $timeout, $q, $urlRouter, $window,
               $uibModal, OrganizationMessageResponses, Session, $state, toastr,
               ClientTypeDetectionService, ServerUrls, $interval, EventTrackingService,
               $uibModalStack, ShepherdTourService, $templateCache, $confirmModalDefaults, GlobalRxFeed) {

    $rootScope.isInternetExplorer = (~window.navigator.userAgent.indexOf('MSIE ') || ~window.navigator.userAgent.indexOf('Trident/'));
    $rootScope.isSafari = (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1);
    $rootScope.isIpad = (navigator.userAgent.indexOf('iPad') != -1);


    $rootScope.registerForbiddenRequest = function(rejection) {

      if ($rootScope.transitioningToRoute) {
        console.log('we\'re transitioning routes', $rootScope.transitioningToRoute);
        toastr.error('You don\'t have permission to do this.  Are you an \'active\' employee?', 'Error');
        if ($window.history.length > 0) {
          $window.history.back();
        } else {
          $state.go('workPeriods', {userId: 'me'});
        }
        return true;
      } else {
        return false;
      }
    };

    if ($rootScope.isInternetExplorer) {
      angular.element('body').addClass('is_ie');
    }

    if ($rootScope.isSafari) {
      angular.element('body').addClass('is_safari');
    }

    if ($rootScope.isIpad) {
      angular.element('body').addClass('is_ipad');
    }

    Angularytics.init();

    $rootScope.transitioningToRoute = {};
    $rootScope.currentRoute = {};

    function doesMatchRoute(routePrefix) {
      return $state.current.name.indexOf(routePrefix, 0) === 0;
    }

    $rootScope.pageState = {
      showLogin: doesMatchRoute('login'),
      showActivate: doesMatchRoute('activateUser'),
      showResetPassword: doesMatchRoute('resetPassword')
    };
    $rootScope.pageState.show = _.any($rootScope.pageState, function(val) { return val; });

    // remove class on run that is keeping login screen over the app
    $('div#fullscreen-overlay').removeClass('force_show');

    $rootScope.transitionPageState = function(pageName, transitionDelay) {
      var fn = function() {
        $rootScope.pageState = {
          showLogin: pageName === 'login',
          showActivate: pageName === 'activate',
          showResetPassword: pageName === 'resetPassword',
          inTransition: false
        };

        $rootScope.pageState.show = _.any($rootScope.pageState, function(attr) {
          return attr;
        });
      };

      if (!_.isUndefined(transitionDelay)) {
        $rootScope.pageState.inTransition = true;
        $timeout(fn, transitionDelay);
      } else {
        fn();
      }
    };

    $rootScope.goToLogin = function(setAuthFailureOccurred) {
      //console.log('goToLogin!!!   logoutCalled: ', $rootScope.logoutCalled);

      // only set the authFailure flag if we're not on login, activateUser, or resetPassword
      if (!_.contains(['login', 'activateUser', 'resetPassword', 'enter'], $state.current.name) && !$rootScope.logoutCalled) {
        $rootScope.authFailureOccurred = !!setAuthFailureOccurred;
        $state.transitionTo('login', {resetCode: undefined, activationCode: undefined});
      }
    };

    $rootScope.$on('$stateChangeStart',
      function(event, toState, toParams, fromState, fromParams) {
        //console.log('$stateChangeStart', toState);
        if (toState.name !== 'login') {
          $rootScope.transitioningToRoute = {state: toState, params: toParams};
        }
        //console.log('start -- transitioningToRoute:', $rootScope.transitioningToRoute, 'currentRoute:', $rootScope.currentRoute.state);
      });

    $rootScope.$on('$stateChangeSuccess',
      function(event, toState, toParams, fromState, fromParams) {
        //console.log('$stateChangeSuccess', toState)
        if (!_.contains(['login', 'activateUser', 'resetPassword', 'enter'], toState.name)) {
          $rootScope.transitioningToRoute = false
          $rootScope.currentRoute = {state: toState, params: toParams}
          GlobalRxFeed.push('state-changed', toState.name, toParams)
        }
        //console.log('success -- transitioningToRoute:', $rootScope.transitioningToRoute, 'currentRoute:', $rootScope.currentRoute.state);
      })

    var theTimeout;
    var unreadMessagesModalOpen = false;
    var lastStoreAnnouncementsCheck;

    $(window).on('resize orientationChanged', function() {
      if (!_.isUndefined(theTimeout)) {
        $timeout.cancel(theTimeout);
      }

      theTimeout = $timeout(function() {
        $rootScope.$broadcast('viewportResizeEvent');
      }, 100);
    });

    $rootScope.$on('$locationChangeSuccess', function (e, newUrl, oldUrl) {
      //console.log(e.name, newUrl, oldUrl);

      EventTrackingService.addEvent('locationChange', { url: newUrl});
      var body = $('body');

      if (!/signup/.test($location.path())) {
        body.removeClass('signup-modals-open');
      }

      if(/^\/manageWorkPeriods/.test($location.path())) {
        $timeout(function() {
          body.addClass('mwp_active');
          body.removeClass('sidebar-menu-open');
        }, 400);
      } else {
        $timeout(function() {
          body.removeClass('mwp_active');
          body.addClass('sidebar-menu-open');
        }, 400);
      }

      var pattern = /manageWorkPeriods\/[0-9]{4}-[0-1]?[0-9]-[0-3]?[0-9]/;
      if (pattern.test(newUrl) && pattern.test(oldUrl) && newUrl !== oldUrl) {
        e.preventDefault();
      }

      var daysOffPattern = /daysOff\/([0-9]{4}-[0-1]?[0-9]-[0-3]?[0-9])/;
      if (daysOffPattern.test(newUrl) && daysOffPattern.test(oldUrl) && newUrl !== oldUrl) {
        e.preventDefault();
      }

      if ( (_.isUndefined(lastStoreAnnouncementsCheck) || moment().isAfter(moment(lastStoreAnnouncementsCheck).add(60, 'seconds'))) &&
           (Session.isLoggedIn()) ) {
        // now let's see about getting unreadOrganizationMessages if we haven't checked in the last 60 seconds
        OrganizationMessageResponses.getMyUnacknowledgedOrganizationMessageResponses()
            .then(function(responses) {
              if(!_.isUndefined(responses)) {
                lastStoreAnnouncementsCheck = moment();
                $rootScope.$broadcast('sa:unreadOrganizationMessages', responses);

              }
            }, function(response) {
            Rollbar.error('Couldn\'t load getMyUnacknowledgedOrganizationMessageResponse', response);
          });
      }

      if (ShepherdTourService.aTourIsActive() && !(/manageWorkPeriods/.test(oldUrl) && /manageWorkPeriods/.test(newUrl))) {
        ShepherdTourService.cancelActiveTour();
      }

    });

    $urlRouter.listen();

    $rootScope.$on('sa:unreadOrganizationMessages', function(event, messageResponses) {
      //console.log('sa:unreadOrganizationMessages');
      if (!unreadMessagesModalOpen && messageResponses.length > 0) {
        unreadMessagesModalOpen = true;

        var modalInstance = $uibModal.open({
          templateUrl: 'views/announcements/newAnnouncementsModal.html',
          size: 'md',
          controllerAs: 'newAnnouncements',
          controller: ['$scope', 'OrganizationMessageResponses', 'params', '$uibModalInstance', '$timeout', function ($scope, OrganizationMessageResponses, params, $uibModalInstance, $timeout) {
            this.messageResponses = params.messageResponses
            this.close = $uibModalInstance.close

            this.acknowledgeMessage = function (messageResp) {
              messageResp.$sendAcknowledgement()
                  .then((function (response) {
                    this.acknowledgementSent = true
                    this.allAcknowledged = lodash.every(this.messageResponses, function (mr) {
                      return mr.acknowledged_at
                    })
                  }).bind(this), lodash.noop)
            }

            $timeout(function() {
              $('.organization_message_embedded_link').on('mousedown', function(e) {
                var omId = parseInt(_.last(e.target.classList).split('-')[1])
                var mr = _.find(this.messageResponses, function(omr) {
                  return omr.organization_message_id ? omr.organization_message_id === omId : omr.organization_message.id === omId
                })
                mr.$trackLink(e.target.href)
              })
            }, 300)
          }],
          resolve: {
            params: { messageResponses: messageResponses }
          }
        })
        modalInstance.result.then(function (result) {
          unreadMessagesModalOpen = false;
        },
        function (reason) {
          console.log('dismissed OrganizationMessageResponseModal with reason ' + reason);
        });
      }
    });

      $rootScope.openOrganizationSignupWizardModal = function() {
        var modalInstance = $uibModal.open({
          // templateUrl: 'views/organizationSignupWizard.html',
          templateUrl: 'views/organizationSignupSimple.html',
          // controller: 'OrganizationSignupWizardCtrl',
          controller: 'OrganizationSignupSimpleCtrl',
          size: 'wizard',
          keyboard: false,
          backdrop: 'static'
        });
      };

      $rootScope.openNewFeaturesModal = function(me) {
        var modalInstance = $uibModal.open({
          size: 'md2',
          templateUrl: 'views/newFeaturesModal.html',
          controller: 'NewFeaturesModalCtrl',
          controllerAs: 'newFeaturesCtrl',
          resolve: { params: function() { return { me: me } } }
        })
      }

      var errorInitInterval = $interval(function() {
        if (window.Rollbar && !window.Rollbar.onload && ServerUrls.matchingServerHost()) {
          window.Rollbar.configure({payload: { environment: ServerUrls.getCurrentErrorEnv()}});
          window.Rollbar.configure({payload: {client_type: ClientTypeDetectionService.getBrowserCharacteristics()}});

          var matchingServer = ServerUrls.matchingServerHost();
          if (lodash.isUndefined(matchingServer) || matchingServer.name === 'development') {
            window.Rollbar.configure({enabled: false});
          }

          var codeId = $('span#before_dist_script_load+script');
          if (codeId && codeId.length > 0) {
            codeId = codeId.attr('src');
            Rollbar.configure({payload: {code_id: codeId}});
          }

          Rollbar.configure({
            transform: function(payload) {
              var context = {};
              context.events = EventTrackingService.getEvents(10);
              if ($uibModalStack.getTop()) {
                context.topModal = {
                  templateUrl: $uibModalStack.getTop().windowTemplateUrl,
                  size: $uibModalStack.getTop().size
                };
              }

              context.path = $location.path();
              context.url = $location.url();
              context.absUrl = $location.absUrl();

              context.isLoggedIn = Session.isLoggedIn().toString();
              if (Session.isLoggedIn() && Session.me) {
                context.orgId = Session.getCurrentOrgId();

                if (context.orgId) {
                  var memb = lodash.find(Session.me.memberships, {organization_id: context.orgId});
                  if (memb) {
                    context.orgName = memb.organization.name;
                  }
                }
              }
              return payload;
            }
          });

          $interval.cancel(errorInitInterval);
        }
      }, 100);

      $rootScope.settings = {};

      $rootScope.setMWPDate = function(newDate) {
        //$rootScope.settings.mwpDate = newDate;
        $rootScope.$broadcast('sa:manageWorkPeriod:dateChangeRequest', {
          moment: newDate
        });
      };

        $templateCache.put('ngDropdowns/templates/dropdownSelectItem.html', [
          '<li>',
          '<a href="" class="dropdown-item"',
          ' ng-href=""',
          ' ng-click="selectItem()">',
          '{{::dropdownSelectItem[dropdownItemLabel]}}',
          '<i class="{{::dropdownSelectItem.icon}}" data-ng-if="dropdownSelectItem.icon"></i>',
          '</a>',
          '</li>'
        ].join(''));

        $templateCache.put('ngDropdowns/templates/dropdownSelect.html', [
          '<div ng-class="{\'disabled\': dropdownDisabled}" class="wrap-dd-select" tabindex="0">',
          '<span class="selected" data-ng-bind="dropdownModel[labelField]"></span>',
          '<ul class="dropdown">',
          '<li ng-repeat="item in dropdownSelect"',
          ' class="dropdown-item"',
          ' dropdown-select-item="::item"',
          ' dropdown-item-label="::labelField">',
          '</li>',
          '</ul>',
          '</div>'
        ].join(''));

        $confirmModalDefaults.size = 'confirm';
        $confirmModalDefaults.template = '<div class="modal-header"><h3 class="modal-title">{{data.title}}</h3></div>' +
        '<div class="modal-body">{{data.text}}</div>' +
        '<div class="modal-footer">' +
        '<div class="options-container">' +
        '<button class="sa_button sa_small sa_blue" ng-click="ok()">{{data.ok}}</button>' +
        '<button class="sa_button sa_small sa_gray" ng-click="cancel()">{{data.cancel}}</button>' +
        '</div>' +
        '</div>';


        var tpl = 'uib/template/timepicker/timepicker.html';
        $templateCache.put(tpl,
          $templateCache.get(tpl).
            replace('style="width:50px;" ', '').
            replace(/glyphicon glyphicon-chevron-up/g, 'icon-chevron-up').
            replace(/glyphicon glyphicon-chevron-down/g, 'icon-chevron-down')
        );

        tpl = 'uib/template/datepicker/day.html';
        $templateCache.put(tpl,
          $templateCache.get(tpl).
            replace(/glyphicon glyphicon-chevron-left/g, 'sa-icon-back').
            replace(/glyphicon glyphicon-chevron-right/g, 'sa-icon-forward')
        );

        tpl = 'uib/template/modal/window.html';
        $templateCache.put(tpl,
          $templateCache.get(tpl).
            replace('1050', '10050')
        );

        tpl = 'uib/template/modal/window.html';
        $templateCache.put(tpl,
          $templateCache.get(tpl).
          replace('ng-style="', 'ng-style="::')
        );

        tpl = 'uib/template/modal/backdrop.html';
        $templateCache.put(tpl,
          $templateCache.get(tpl).
            replace('1040', '10040')
        );

        tpl = 'uib/template/modal/backdrop.html';
        $templateCache.put(tpl,
          $templateCache.get(tpl).
          replace('ng-style="', 'ng-style="::')
        );

        if (Session.isLoggedIn()) {
          $q.all([ Session.getMe(), Session.getCurrentOrg() ])
            .then(function (result) {
              var currentMemb = lodash.find(result[0].memberships, { organization_id: Session.getCurrentOrgId() })
              if (currentMemb && currentMemb.role === 'admin' && !lodash.has(result[0].completed_tours, 'newfeature-payrates-tour') && moment(result[1].created_at).isBefore('2017-07-01')) {
                toastr.info('We have updated Shift Agent with some new features. Click here to learn more!', 'New Features!', {
                  allowHtml: true,
                  closeButton: true,
                  timeOut: 0,
                  extendedTimeOut: 0,
                  onTap: function () {
                    $rootScope.openNewFeaturesModal(result[0])
                  }
                })
              }
            })
        }
  }]);
